import AllOn4Protocol from "./all-on-4";
import AllOn6Protocol from "./all-on-6";
// import AllOn8Protocol from "./all-on-8";
// import FullJaw10Protocol from "./full-jaw-10";
import FullJaw8Protocol from "./full-jaw-8";
import FullJaw6Protocol from "./full-jaw-6";
import OnePhase8Protocol from "./one-phase-8";
import FullBridgeProtocol from "./full-bridge";
import BridgeProtocol from "./bridge";
// import BridgePostProtocol from "./bridge-post";
import BridgeImplantsProtocol from "./bridge-implants";
import CrownProtocol from "./crown";
// import CrownPostProtocol from "./crown-post";
import CrownImplantsProtocol from "./crown-implants";
import VeneerProtocol from "./veneer";
import PreciVertixProtocol from "./preci-vertix";
import FastAndFixed4Protocol from "./bredent-fast-and-fixed-4";
import FastAndFixed6Protocol from "./bredent-fast-and-fixed-6";
import Mini4Protocol from "./mini-4";
import Mini6Protocol from "./mini-6";
import FullJaw612Protocol from "./full-jaw-6-12";
import FullJaw614Protocol from "./full-jaw-6-14";
import FullJaw812Protocol from "./full-jaw-8-12";
import FullJaw814Protocol from "./full-jaw-8-14";
import BridgeImplantsOnePhaseProtocol from "./bridge-implants-one-phase";
import CrownImplantsOnePhaseProtocol from "./crown-implants-one-phase";
import FullDenturesProtocol from "./full-dentures";
import DenturesWithBarProtocol from "./dentures-with-bar";

export default {
    all_on_4: AllOn4Protocol,
    all_on_6: AllOn6Protocol,
    fast_and_fixed_4: FastAndFixed4Protocol,
    fast_and_fixed_6: FastAndFixed6Protocol,
    // all_on_8: AllOn8Protocol,
    // full_jaw_10: FullJaw10Protocol,
    //full_jaw_8: FullJaw8Protocol,
    //full_jaw_6: FullJaw6Protocol,
    full_jaw_6_12: FullJaw612Protocol,
    full_jaw_6_14: FullJaw614Protocol,
    full_jaw_8_12: FullJaw812Protocol,
    full_jaw_8_14: FullJaw814Protocol,
    one_phase_8: OnePhase8Protocol,
    mini_4: Mini4Protocol,
    mini_6: Mini6Protocol,
    preci_vertix: PreciVertixProtocol,
    full_bridge: FullBridgeProtocol,
    full_dentures: FullDenturesProtocol,
    dentures_with_bar: DenturesWithBarProtocol,
    crown: CrownProtocol,
    bridge: BridgeProtocol,
    veneer: VeneerProtocol,
    // crown_post: CrownPostProtocol,
    crown_implants: CrownImplantsProtocol,
    crown_implants_one_phase: CrownImplantsOnePhaseProtocol,
    // bridge_post: BridgePostProtocol,
    bridge_implants: BridgeImplantsProtocol,
    bridge_implants_one_phase: BridgeImplantsOnePhaseProtocol,
};
